// Astarte-on-glitch: decorations (MathJax rendering, BBCode inline styles)
// are only applied to statuses authored on this server. Remote content is
// shown as the plain HTML the sanitizer lets through.

// A remote account's acct is `user@domain`; local accounts have no domain.
export function isRemoteAcct(acct: string | null | undefined): boolean {
  return typeof acct === 'string' && acct.includes('@');
}
